import { render, staticRenderFns } from "./tinyMce.vue?vue&type=template&id=74fe35f2&"
import script from "./tinyMce.vue?vue&type=script&lang=js&"
export * from "./tinyMce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports